module.exports = __webpack_public_path__ + "img/sne.af0d370b.png";